import { Link as RouterLink } from 'react-router-dom';

export default function Link({ ...props }){
    return <RouterLink className={'router-link'} {...props} />
}
